import React, { useContext } from "react";
import withStyles from '@mui/styles/withStyles';
import { Box, Typography } from "@mui/material";
import ProgressBarRow from "./progress-bar-row";
import AchievementsContext from "../../contexts/achievements-context";

const styles = (theme) => ({
  root: {
    marginTop: 30,
    paddingBottom: 50,
    borderRadius: "0 0 0 60px",
    backgroundColor: "#f6f5f6",
    zIndex: -2,
  },
  heading: {
    fontSize: 16,
    fontWeight: 300,
    marginBottom: 10,
    color: "gray",
  },
  innerBox: {
    marginLeft: 30,
    marginRight: 30,
  },
});

const CourseProgress = ({ classes }) => {
  const { courseStatistics } = useContext(AchievementsContext);

  return (
    <div style={{ backgroundColor: "#7FC5ED" }}>
      <Box width="100%" className={classes.root}>
        <Box className={classes.innerBox}>
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
              marginBottom: "-4vh",
            }}
          >
            <Typography
              align="left"
              variant="body1"
              component="div"
              color="inherit"
              className={classes.heading}
            >
              <p style={{}}>Kurse</p>
            </Typography>
            <Typography
              align="right"
              variant="body1"
              component="div"
              color="inherit"
              className={classes.heading}
              style={{ align: "right" }}
            >
              <p style={{}}> Punkte </p>
            </Typography>
          </div>
          {courseStatistics.map((statistic) => (
            <ProgressBarRow key={statistic.courseId} statistic={statistic} />
          ))}
        </Box>
      </Box>
    </div>
  );
};

export default withStyles(styles)(CourseProgress);
